import React from 'react'


import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from 'gatsby'

import { nanoid } from 'nanoid'
import { Icon } from '@iconify/react';

import Layout from '../components/layout'

const Blog = () => {

    const blogPosts = useStaticQuery(graphql`
        query {
            allContentfulBlogPost(sort: {order: DESC, fields: date}) {
                nodes {
                    title
                    featuredImage {
                        gatsbyImageData(
                            placeholder: BLURRED
                            layout: CONSTRAINED
                        )
                    }
                    date(formatString: "MMMM D YYYY")
                    excerpt
                    slug
                }
            }
        }
    `).allContentfulBlogPost.nodes

    return (
        <Layout showHeader={true}>
            <div>
                <div className="has-text-centered mt-6" style={{ position: 'sticky', marginBottom: '4rem' }}>
                    <span className="is-size-1 the-black-pill-title is-size-3-mobile">
                        <h3 className="super-title mr-3">
                            The Black Pill
                        </h3>
                        <Icon icon="fluent:pill-20-filled" color="#d6b455" className="is-size-1-mobile" />
                    </span>
                    <p className="is-size-5 body-text">Out of the abundance of the heart, the mouth speaks</p>
                </div>
                {
                    blogPosts.map(({ title, featuredImage, date, excerpt, slug }, index) => 
                        <Link to={`/the-black-pill/${slug}`} key={nanoid()}>
                            <div className="columns is-vcentered mt-3 blogpost py-3 has-text-centered-mobile" tabIndex={index}>
                                <GatsbyImage image={getImage(featuredImage)} alt={title} className="column is-one-third" style={{height: '250px'}} imgStyle={{objectFit: 'contain'}} />
                                <div className="column is-two-thirds">
                                    <p className="is-size-5">{date}</p>
                                    <h2 className="column is-size-2 is-size-3-mobile pl-0">{title}</h2>
                                    <p className="is-size-4 is-size-5-mobile body-text">{excerpt}</p>
                                </div>
                            </div>
                        </Link>
                    )
                }
            </div>
        </Layout>
    )
}

export default Blog
